<h2 mat-dialog-title> {{formTitle}}</h2>
<p-toast [style]="{marginTop: '80px'}">
</p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="container-fluid">
  @if (!rateBucket) {
    <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
      <mat-icon>close</mat-icon>
    </button>
  }

  <mat-dialog-content>
    <div [formGroup]="form1">
      <div class="row wrap">
        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100" style="padding:10px;">
              <div class="w-100" style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>
        <div class="col-md-12 col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" readonly="{{formReadOnly}}">
            @for (validation of validationMessages.name; track validation) {
              <mat-error>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <mat-error class="error-message">
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-12">
          <mat-form-field class="w-100">
            <mat-label>General Description</mat-label>
            <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="500"
            matTooltip="Enter description, paragrphs are ok."></textarea>
            @for (validation of validationMessages.description; track validation) {
              <mat-error>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <mat-error class="error-message">
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-12" style="padding: 8px 0 12px 0;">
          <mat-slide-toggle formControlName="flexiblePolicyToggle">
            Flexible Policy Eligible
          </mat-slide-toggle>
          <mat-icon
            style="font-size:18px;vertical-align:middle;margin-left:6px;color:#666;cursor:help;"
            matTooltip="When ON: cancellations in this rate season may use Flexible policy if the property toggle is also ON, arrival is within 14 days, and occupancy is under 60%. When OFF: this season always uses Standard Strict regardless of any other setting. Restricted seasons (Christmas Hawaii, New Year Hawaii, Holiday Utah, New Year Utah, High Winter Utah) are always Standard Strict."
            matTooltipShowDelay="200">info_outline</mat-icon>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="row">
      <div class="col-lg-12">
        <div class="w-100">
          @if (rateBucketId) {
            <button style="float:left;" mat-raised-button color="error" (click)="onFormDelete()" [disabled]="!form1.valid">Delete RateBucket</button>
          }
          @if (rateBucketId) {
            <button style="float:right;" mat-raised-button color="primary" (click)="formUpdate()" [disabled]="!form1.valid">Update RateBucket</button>
          }
          @if (!rateBucketId) {
            <button style="float:right;" mat-raised-button color="primary" (click)="formAdd()" [disabled]="!form1.valid">Add RateBucket</button>
          }
          @if (!rateBucketId) {
            <button style="float:left;" mat-raised-button [mat-dialog-close]="true">Done</button>
          }
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</div>